import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6900Model } from "../kymw6900.model";
import { GetGoodsProposalInfoService } from "./get-goods-proposal-info.service";


/**
 * 提案ステータスを更新するサービス
 *
 * @export UpdateSuggestionStatusService
 * @class UpdateSuggestionStatusService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateSuggestionStatusService extends PlessJsonResponderSub<unknown> {
  private model: KYMW6900Model;
  private proposalStatus = '';
  private sucessFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    private getGoodsProposalInfoService: GetGoodsProposalInfoService
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateSuggestionStatusService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        ProposalIdList: {
          parameter: {
            ProposalStatus: this.proposalStatus
          },
          combination: this.model.selectedProposalIds.map(proposalId => (
            {
              condition: {
                ProposalId: proposalId
              }
            }
          ))
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateSuggestionStatusService
   */
  execute(model: KYMW6900Model, proposalStatus: string, successFunc: Function) {
    this.model = model;
    this.proposalStatus = proposalStatus;
    this.sucessFunc = successFunc;
    this.send('updateSuggestionStatus', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof UpdateSuggestionStatusService
   */
  success(): void {
    this.model.clearSelectedProposalIds();
    if (this.sucessFunc) {
      this.sucessFunc();
    }
  }
}
